import { render, staticRenderFns } from "./trainermodal.vue?vue&type=template&id=c276b9de"
import script from "./trainermodal.vue?vue&type=script&lang=js"
export * from "./trainermodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports